import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface InstructorDetailsForm {
  fieldName: string;
}

export interface InstructorDetails {
  _id: string;
  studio: string;
  fieldName: string;
  fieldType: string;
}

export const createInstructorAPI = async (
  instructorDetails: InstructorDetailsForm,
) => {
  const resp = await baseAPI.post<InstructorDetails>(
    '/custom-form/instructor',
    instructorDetails,
  );
  return resp.data;
};

export const useCreateInstructorMutation = () => {
  return useMutation({
    mutationFn: async (instructorDetails: InstructorDetailsForm) => {
      const response = await createInstructorAPI(instructorDetails);
      return response;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.INSTRUCTORS],
      });
    },
  });
};
